import React from 'react';
import { useTheme } from '../hooks/useTheme';
import Icon from './AppIcon';

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative p-2.5 rounded-lg transition-all duration-300 
        bg-surface border-2 border-border 
        hover:border-primary hover:bg-primary/10 hover:scale-110 
        active:scale-95 shadow-sm hover:shadow-md ${className}`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="relative w-5 h-5 flex items-center justify-center">
        {theme === 'light' ? (
          <Icon 
            name="Moon" 
            size={20} 
            className="text-primary animate-fade-in"
            strokeWidth={2}
          />
        ) : (
          <Icon 
            name="Sun" 
            size={20} 
            className="text-primary animate-fade-in"
            strokeWidth={2}
          />
        )}
      </div>
    </button>
  );
};

export default ThemeToggle;